import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import config from '../../config.json';
import template from './foot.vue';

@Component({
    mixins: [template],
})
export default class Foot extends Vue {
    version: string = `${config.version}`;
    build: string = `${config.build}`;

    // using iframe to login to TMS, so that it allows ajax call to TMS
    iframeLoginSource: string = `https://${this.getDomain()}/js/crosslogin.php?CompanyID=${
        localStorage.CompanyID
    }&UserGroupID=${localStorage.UserGroupID}&UserID=${localStorage.UserID}&UserToken=${
        localStorage.UserToken
    }`;

    getDomain() {
        let host = window.location.hostname;
        let domain;

        if (host == 'localhost' || host == 'clientdev.freightapp.com') {
            domain = 'dev.freightapp.com';
        } else if (host == 'clientstage.freightapp.com' || host == 'shipstage.unisco.com') {
            domain = 'staging.freightapp.com';
        } else if (
            host == 'client.freightapp.com' ||
            host == 'ship.unisco.com' ||
            host == 'demo.unisco.com'
        ) {
            domain = 'tms.freightapp.com';
        }

        return domain;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/foot/index.ts